export default "/images/e759cbb678e747f2a8f2a56023186b12.avif";